module.exports = __webpack_public_path__ + "static/media/velour11C.dd9cd694.jpg";